import { render, staticRenderFns } from "./PopupActivatedAccount.vue?vue&type=template&id=6d552ab1&"
import script from "./PopupActivatedAccount.vue?vue&type=script&lang=js&"
export * from "./PopupActivatedAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports